// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AI API Settings — compact form layout */

.ai-page {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 640px;
  height: calc(100vh - 100px);
  min-height: 400px;
}

.ai-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.ai-toolbar-note {
  flex: 1 1;
  font-size: 15px;
  color: #94a3b8;
  min-width: 160px;
}

.ai-tabs {
  display: flex;
  gap: 6px;
  padding: 4px;
  background: #f1f5f9;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  flex-shrink: 0;
}

.ai-tab {
  padding: 8px 14px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #64748b;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.ai-tab:hover {
  color: #334155;
}

.ai-tab--active {
  background: #fff;
  color: #2563eb;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.ai-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.ai-btn:hover:not(:disabled) {
  background: #f8fafc;
}

.ai-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.ai-btn--primary {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}

.ai-btn--primary:hover:not(:disabled) {
  background: #1d4ed8;
}

.ai-toast {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 15px;
  flex-shrink: 0;
}

.ai-toast button {
  border: none;
  background: none;
  cursor: pointer;
  color: inherit;
  opacity: 0.7;
}

.ai-toast--ok {
  background: #ecfdf5;
  color: #047857;
  border: 1px solid #bbf7d0;
}

.ai-toast--err {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.ai-panel {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 16px;
}

.ai-field {
  margin-bottom: 14px;
}

.ai-field label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 5px;
}

.ai-field input[type="text"],
.ai-field input[type="password"] {
  width: 100%;
  padding: 9px 11px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  color: #0f172a;
  box-sizing: border-box;
}

.ai-field input:focus {
  outline: none;
  border-color: #93c5fd;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.12);
}

.ai-hint {
  font-size: 13px;
  color: #94a3b8;
  margin-top: 4px;
}

.ai-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.ai-toggle-label {
  font-size: 15px;
  color: #334155;
  font-weight: 500;
}

.ai-toggle-hint {
  display: block;
  font-size: 13px;
  color: #94a3b8;
  font-weight: 400;
  margin-top: 2px;
}

.ai-switch {
  position: relative;
  width: 40px;
  height: 22px;
  flex-shrink: 0;
}

.ai-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.ai-switch-slider {
  position: absolute;
  inset: 0;
  background: #cbd5e1;
  border-radius: 999px;
  cursor: pointer;
  transition: background 0.2s;
}

.ai-switch-slider::before {
  content: '';
  position: absolute;
  width: 18px;
  height: 18px;
  left: 2px;
  top: 2px;
  background: #fff;
  border-radius: 50%;
  transition: transform 0.2s;
}

.ai-switch input:checked + .ai-switch-slider {
  background: #2563eb;
}

.ai-switch input:checked + .ai-switch-slider::before {
  transform: translateX(18px);
}

.ai-info {
  flex-shrink: 0;
  padding: 10px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  color: #64748b;
  line-height: 1.45;
}

.ai-info strong {
  color: #475569;
}

.ai-loading {
  padding: 48px;
  text-align: center;
  color: #94a3b8;
  font-size: 15px;
}

.ai-spin {
  animation: ai-spin 0.8s linear infinite;
}

@keyframes ai-spin {
  to { transform: rotate(360deg); }
}

@media (max-width: 640px) {
  .ai-page {
    height: auto;
    max-width: none;
  }

  .ai-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .ai-tabs {
    width: 100%;
    justify-content: stretch;
  }

  .ai-tab {
    flex: 1 1;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AISettingsPage.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,wBAAwB;EAC1B;;EAEA;IACE,SAAO;IACP,kBAAkB;EACpB;AACF","sourcesContent":["/* AI API Settings — compact form layout */\n\n.ai-page {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  max-width: 640px;\n  height: calc(100vh - 100px);\n  min-height: 400px;\n}\n\n.ai-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n\n.ai-toolbar-note {\n  flex: 1;\n  font-size: 15px;\n  color: #94a3b8;\n  min-width: 160px;\n}\n\n.ai-tabs {\n  display: flex;\n  gap: 6px;\n  padding: 4px;\n  background: #f1f5f9;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  flex-shrink: 0;\n}\n\n.ai-tab {\n  padding: 8px 14px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #64748b;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n}\n\n.ai-tab:hover {\n  color: #334155;\n}\n\n.ai-tab--active {\n  background: #fff;\n  color: #2563eb;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.ai-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #475569;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.ai-btn:hover:not(:disabled) {\n  background: #f8fafc;\n}\n\n.ai-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.ai-btn--primary {\n  background: #2563eb;\n  border-color: #2563eb;\n  color: #fff;\n}\n\n.ai-btn--primary:hover:not(:disabled) {\n  background: #1d4ed8;\n}\n\n.ai-toast {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  font-size: 15px;\n  flex-shrink: 0;\n}\n\n.ai-toast button {\n  border: none;\n  background: none;\n  cursor: pointer;\n  color: inherit;\n  opacity: 0.7;\n}\n\n.ai-toast--ok {\n  background: #ecfdf5;\n  color: #047857;\n  border: 1px solid #bbf7d0;\n}\n\n.ai-toast--err {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.ai-panel {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 16px;\n}\n\n.ai-field {\n  margin-bottom: 14px;\n}\n\n.ai-field label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-bottom: 5px;\n}\n\n.ai-field input[type=\"text\"],\n.ai-field input[type=\"password\"] {\n  width: 100%;\n  padding: 9px 11px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 15px;\n  color: #0f172a;\n  box-sizing: border-box;\n}\n\n.ai-field input:focus {\n  outline: none;\n  border-color: #93c5fd;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.12);\n}\n\n.ai-hint {\n  font-size: 13px;\n  color: #94a3b8;\n  margin-top: 4px;\n}\n\n.ai-toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 12px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n}\n\n.ai-toggle-label {\n  font-size: 15px;\n  color: #334155;\n  font-weight: 500;\n}\n\n.ai-toggle-hint {\n  display: block;\n  font-size: 13px;\n  color: #94a3b8;\n  font-weight: 400;\n  margin-top: 2px;\n}\n\n.ai-switch {\n  position: relative;\n  width: 40px;\n  height: 22px;\n  flex-shrink: 0;\n}\n\n.ai-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.ai-switch-slider {\n  position: absolute;\n  inset: 0;\n  background: #cbd5e1;\n  border-radius: 999px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.ai-switch-slider::before {\n  content: '';\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  left: 2px;\n  top: 2px;\n  background: #fff;\n  border-radius: 50%;\n  transition: transform 0.2s;\n}\n\n.ai-switch input:checked + .ai-switch-slider {\n  background: #2563eb;\n}\n\n.ai-switch input:checked + .ai-switch-slider::before {\n  transform: translateX(18px);\n}\n\n.ai-info {\n  flex-shrink: 0;\n  padding: 10px 12px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 15px;\n  color: #64748b;\n  line-height: 1.45;\n}\n\n.ai-info strong {\n  color: #475569;\n}\n\n.ai-loading {\n  padding: 48px;\n  text-align: center;\n  color: #94a3b8;\n  font-size: 15px;\n}\n\n.ai-spin {\n  animation: ai-spin 0.8s linear infinite;\n}\n\n@keyframes ai-spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 640px) {\n  .ai-page {\n    height: auto;\n    max-width: none;\n  }\n\n  .ai-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .ai-tabs {\n    width: 100%;\n    justify-content: stretch;\n  }\n\n  .ai-tab {\n    flex: 1;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
